import { ComponentType, lazy } from "react";

/**
 * Maps componentKey strings (from Sanity/manifest) to React components.
 *
 * Only steps with complex custom UI that can't be driven by SchemaFormRenderer
 * are registered here. All other steps render via GenericStepPage.
 *
 * All components are lazy-loaded for code splitting.
 */

const ServiceSelector = lazy(() =>
  import("../../../features/service-selector").then((m) => ({
    default: m.ServiceSelector,
  })),
);
const AvailabilityForm = lazy(() =>
  import("../../../features/availability-form").then((m) => ({
    default: m.AvailabilityForm,
  })),
);
const PricingList = lazy(() =>
  import("../../../features/pricing-list").then((m) => ({
    default: m.PricingList,
  })),
);
const ConfirmationButtons = lazy(() =>
  import("../../../features/confirmation/confirmation-buttons").then((m) => ({
    default: m.ConfirmationButtons,
  })),
);
const ConfirmationSummary = lazy(() =>
  import("../../../features/confirmation/confirmation-summary").then((m) => ({
    default: m.ConfirmationSummary,
  })),
);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const componentRegistry: Record<string, ComponentType<any>> = {
  "service-selector": ServiceSelector,
  "availability-form": AvailabilityForm,
  "pricing-list": PricingList,
  "confirmation-buttons": ConfirmationButtons,
  "confirmation-summary": ConfirmationSummary,
  "confirmation-summary-junk": ConfirmationSummary,
};
